<template>
    <div class="select-box shadow-sm">
        <div class="options-container" :class="isActive">
            <div
                class="option"
                v-for="option in options"
                :key="option.id"
                @click="selectMenu(option)"
            >
                <label for>{{ option.name }}</label>
            </div>
        </div>
        <div
            class="selected-filter d-flex align-items-center"
            @click="openMenu"
        >
            <i class="text-gray-light la la-2x mr-3" :class="icon"></i
            >{{ showText }}
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: null,
        },
        options: {
            type: Array,
            default: null,
        },
        icon: {
            type: String,
            default: null,
        },
        value: {
            type: Object,
        },
    },
    data() {
        return {
            isActive: null,
            showText: this.title,
        };
    },
    methods: {
        openMenu() {
            if (this.isActive == null) {
                this.isActive = "active";
            } else {
                this.isActive = null;
            }
        },
        selectMenu(option) {
            this.showText = option.name;
            this.isActive = null;
            this.$emit("input", option);
        },
    },
    watch: {
        value: function (newVal, oldVal) {
            //for reset if null value
            if (newVal.name == null) {
                this.isActive = null;
                this.showText = this.title;
            }
        },
    },
};
</script>
